import * as React from 'react';
import * as styles from './styles.module.scss';

interface Props {
  width?: string;
  height?: string;
  color?: string;
  title?: string;
  onClick?: () => void;
}

const RevertIcon = ({ width, height, color, title, onClick }: Props) => {
  return (
    <svg
      onClick={onClick}
      className={styles.revertIcon}
      width={width || '24'}
      height={height || '24'}
      viewBox="0 0 24 24"
    >
      <path
        fill={color || '#000000'}
        d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M12.16,14.31C10.6,14.31 9.19,14.89 8.11,15.83L6,13.72V19H11.28L9.15,16.88C9.97,16.2 11,15.78 12.16,15.78C14.23,15.78 16,17.13 16.61,19L18,18.54C17.19,16.09 14.88,14.31 12.16,14.31Z"
      />
    </svg>
  );
};

export default RevertIcon;
